<template>
  <div>
    <div class="medium-small-text-font mb-2 text-center">Initial Estimated Rate
    </div>
    <div class="d-flex flex1 align-center justify-center" style="gap: 12px;">


      <div class="small-text-font mr-2 mr-sm-0">{{ label }}</div>
      <div style="max-width: 400px;">
        <v-select class="py-2" hide-details :items="allInterestRateScenario" dense outlined
          :value="currentInterestRateScenario"
          @change="(value) => handleScenarioOptionsChange(value, 'interestRateScenario')" :disabled="isUpdating"
          :readonly="isResultSaved" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['label'],
  computed: {
    allInterestRateScenario() {
      const allOptionsObject =
        this.$store.state.scenarioData.currentScenarioData.selectsOptions
          .interestRateScenarioOptions;
      return Object.values(allOptionsObject);
    },
    currentInterestRateScenario() {
      return this.$store.state.scenarioData.currentScenarioData.selectsOptions.selected
        .interestRateScenario;
    },
    isUpdating() {
      return this.$store.state.isUpdating;
    },
    isResultSaved() {
      return this.$store.getters.isResultSaved;
    }
  },
  methods: {
    handleScenarioOptionsChange(value, fieldName) {
      const data = { fieldName, value };
      this.$store.commit('changeOptionValues', data);
      this.$store.dispatch('getNewScenarioData');
    }
  }
};
</script>
